import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// Capitulos IV (Personal) + V (Comision). Render condicional por cap.
export default function PersonalComisionPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const cv = config.capitulosVisibles;
  const verPer = !!cv.personal;
  const verCom = !!cv.comision;
  const secNum = String(pagNum - 2).padStart(2, "0");

  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Personal y comisión</span>
        <h2 className="big">Quién <em>opera</em> el edificio.</h2>

        {verPer && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.personal}</div>
              <h3 className="art-title">Personal del edificio</h3>
            </div>
            <p className="art-lede">El personal recibe órdenes únicamente de la Comisión y/o el Administrador.</p>
            <ol className="rules">
              <li><span className="m">a</span><span>Avisar de inmediato cualquier acontecimiento de importancia.</span></li>
              <li><span className="m">b</span><span>Trasladar reclamos de copropietarios al Administrador o Comisión.</span></li>
              <li><span className="m">c</span><span>Mantener en perfecto estado las partes comunes.</span></li>
              <li><span className="m">d</span><span>Anunciar previamente a los visitantes a la unidad correspondiente.</span></li>
              <li><span className="m">e</span><span>Impedir entrada de vendedores ambulantes; vigilar proveedores individualizados.</span></li>
              <li><span className="m">f</span><span>Entregar sin demoras correspondencia, encomiendas y bultos.</span></li>
              <li><span className="m">g</span><span>Acatar y firmar todas las órdenes escritas de Comisión y Administración.</span></li>
              <li><span className="m">h</span><span>No prestar servicios particulares dentro del horario laboral.</span></li>
            </ol>
          </div>
        )}

        {verCom && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.comision}</div>
              <h3 className="art-title">Comisión del edificio</h3>
            </div>
            <h4 className="sub-h">Competencia</h4>
            <ol className="rules">
              <li><span className="m">a</span><span>Órgano de gestión y control de la Administración.</span></li>
              <li><span className="m">b</span><span><b>Hasta 7 miembros</b>, designados anualmente por la Asamblea.</span></li>
              <li><span className="m">c</span><span>Sesiona en lugar, día y hora que fijen sus integrantes.</span></li>
              <li><span className="m">d</span><span>Resoluciones por <b>mayoría simple</b> con quórum mínimo de 3.</span></li>
              <li><span className="m">e</span><span>Cargos exclusivos para propietarios y promitentes compradores.</span></li>
              <li><span className="m">f</span><span>Rinde cuentas <b>anualmente</b> en Asamblea Ordinaria.</span></li>
            </ol>
            <h4 className="sub-h">Cometidos</h4>
            <ol className="rules">
              <li><span className="m">a</span><span>Proyectar reformas del Reglamento de Copropiedad.</span></li>
              <li><span className="m">b</span><span>Trasladar inquietudes al Administrador.</span></li>
              <li><span className="m">c</span><span>Formular observaciones al funcionamiento del edificio.</span></li>
              <li><span className="m">d</span><span>Supervisar gestión, presupuestos y desempeño del personal.</span></li>
              <li><span className="m">e</span><span>Examinar rendiciones de cuentas y cálculos de gastos.</span></li>
            </ol>
          </div>
        )}
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
